import { AvgTransportSpeedUI } from '../types/interfaces';

export const AvgTransportSpeedTemplate: AvgTransportSpeedUI = {
  id: 0,
  name: '',
  description: '',
  value: '',
  roadCurvature: 1,
};
